import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  action?: ReactNode;
  /** A picture before the title — a product's main photo. */
  media?: ReactNode;
};

export const PageHeader = ({ title, subtitle, action, media }: PageHeaderProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      gap: 2,
      mb: 3,
      flexWrap: 'wrap',
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {media}
      <Box>
        <Typography variant="h4">{title}</Typography>
        {subtitle ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.75, maxWidth: 760, lineHeight: 1.55 }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
    </Box>
    {action}
  </Box>
);
